export enum LocationRequirementStatus {
  NotOnSite = 'Not On Site',
  PositionError = 'Position Error',
  Passed = 'Passed',
  NotPrecise = 'Not Precise',
}
